import { mapCollection } from '../../utils/collection.utils';
import { Company } from '../company';

export class CompanyBuilder {
  static fromJson(json) {
    return (json)
      ? new Company(
        json.hash,
        json.commercialName,
        json.businessName,
        json.taxNumber
      )
      : null;
  }

  static fromList(list) {
    return (Array.isArray(list)) ? mapCollection(CompanyBuilder.fromJson, list) : [];
  }
}
